export var BeaconType;
(function (BeaconType) {
    BeaconType["PRODUCT"] = "product";
    BeaconType["CART"] = "cart";
    BeaconType["ORDER"] = "transaction";
    BeaconType["LOGIN"] = "login";
    BeaconType["CLICK"] = "click";
    BeaconType["CUSTOM"] = "custom";
    /** For Profiles Recommendations */
    BeaconType["PROFILE_RENDER"] = "profile.render";
    BeaconType["PROFILE_IMPRESSION"] = "profile.impression";
    BeaconType["PROFILE_CLICK"] = "profile.click";
    /** For Recommended Products within a Profile */
    BeaconType["PROFILE_PRODUCT_RENDER"] = "profile.product.render";
    BeaconType["PROFILE_PRODUCT_IMPRESSION"] = "profile.product.impression";
    BeaconType["PROFILE_PRODUCT_CLICK"] = "profile.product.click";
})(BeaconType || (BeaconType = {}));
export var BeaconCategory;
(function (BeaconCategory) {
    BeaconCategory["PAGEVIEW"] = "searchspring.page.view";
    BeaconCategory["CARTVIEW"] = "searchspring.shop.cart";
    BeaconCategory["ORDERVIEW"] = "searchspring.shop.transaction";
    BeaconCategory["PERSONALIZATION"] = "searchspring.personalization";
    BeaconCategory["RECOMMENDATIONS"] = "searchspring.recommendations.user-interactions";
    BeaconCategory["INTERACTION"] = "searchspring.user-interactions";
    BeaconCategory["CUSTOM"] = "custom";
})(BeaconCategory || (BeaconCategory = {}));
